import type { ICancellationToken } from '@cian/http-api';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';
import { type GetRealClustersResponse } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

import {
  type IGetClustersForMapResponse200,
  type IGetClustersForMapResponse400,
  type TGetClustersForMapRequest,
  createGetClustersForMapModel,
  fetchGetClustersForMap,
} from '@/repositories/generated/shared/search-offers-index/v2/get-clusters-for-map';

import { prepareClusters } from './mappers';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
  parameters: TGetClustersForMapRequest;
};

export function fetchGetClustersService(params: FetchServiceParams): Promise<GetRealClustersResponse> {
  const {
    applicationContext: { httpApi, logger },
    cancellationToken,
    parameters,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createGetClustersForMapModel(parameters),
    '@/shared/store/serverSide/search-offers-index/v2/get-clusters-for-map/internal/fetchService.ts',
    logger,
  );

  return fetchGetClustersForMap<IGetClustersForMapResponse200, IGetClustersForMapResponse400>({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          /**
           * Зачем это сделано.
           * Для уменьшения кол-ва данных, гоняемых по сети, мы убрали несколько технических полей из респонса,
           * которые нам нужны на фронте.
           * Эти поля мы добавляем здесь, мутируя ответ.
           */
          return prepareClusters(result.response);
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
